import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { photos } from '../../constants/photoData'

const Carrusel = () => {

    return (
        <section className="bg-[#1e293b] p-8">
            <div className="max-w-5xl mx-auto text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold mb-4">Nuestros Trabajos</h2>
                <p className="text-white/80 text-lg">
                    Instalaciones y proyectos realizados
                </p>
            </div>

            <div className="max-w-5xl mx-auto">
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    navigation={true}
                    pagination={{ clickable: true }}
                    className="rounded-xl overflow-hidden"
                    style={{
                        "--swiper-navigation-color": "#8b5cf6", // cambia color de flechas
                        "--swiper-pagination-color": "#8b5cf6"   // cambia color de los bullets si quieres
                    }}
                >
                    {photos.map((photo, i) => (
                        <SwiperSlide key={i}>
                            <div className="w-full h-[300px] sm:h-[400px] md:h-[400px]">
                                <img
                                    src={photo}
                                    alt={`Trabajo ${i + 1}`}
                                    className="w-full h-full object-cover rounded-xl"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    )
}
export default Carrusel 